'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest from "./presto.-Agent-View$-Local-Shodo-Cert-Chain-Request.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoCertChainRequest$() {
}
export { $c_Lpresto_AgentView$LocalShodoCertChainRequest$ as $c_Lpresto_AgentView$LocalShodoCertChainRequest$ };
$p = $c_Lpresto_AgentView$LocalShodoCertChainRequest$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoCertChainRequest$;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoCertChainRequest$() {
}
export { $h_Lpresto_AgentView$LocalShodoCertChainRequest$ as $h_Lpresto_AgentView$LocalShodoCertChainRequest$ };
$h_Lpresto_AgentView$LocalShodoCertChainRequest$.prototype = $p;
$p.l = (function() {
  return "LocalShodoCertChainRequest";
});
$p.cFY = (function(x$0) {
  return new $j_presto$002e$002dAgent$002dView$0024$002dLocal$002dShodo$002dCert$002dChain$002dRequest.$c_Lpresto_AgentView$LocalShodoCertChainRequest(x$0.j(0));
});
var $d_Lpresto_AgentView$LocalShodoCertChainRequest$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoCertChainRequest$, "presto.AgentView$LocalShodoCertChainRequest$", ({
  El: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_AgentView$LocalShodoCertChainRequest$ as $d_Lpresto_AgentView$LocalShodoCertChainRequest$ };
var $n_Lpresto_AgentView$LocalShodoCertChainRequest$;
function $m_Lpresto_AgentView$LocalShodoCertChainRequest$() {
  if ((!$n_Lpresto_AgentView$LocalShodoCertChainRequest$)) {
    $n_Lpresto_AgentView$LocalShodoCertChainRequest$ = new $c_Lpresto_AgentView$LocalShodoCertChainRequest$();
  }
  return $n_Lpresto_AgentView$LocalShodoCertChainRequest$;
}
export { $m_Lpresto_AgentView$LocalShodoCertChainRequest$ as $m_Lpresto_AgentView$LocalShodoCertChainRequest$ };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Cert-Chain-Request$.js.map
